import Vue from 'vue'
import Router from 'vue-router'
import Tracker from '@/components/Tracker'
import Replay from '@/components/Replay'
import Request from '@/components/Request'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: Tracker
    },
    {
      path: '/replay',
      name: 'replay',
      component: Replay
    },
    {
      path: '/tracker',
      name: 'tracker',
      component: Tracker
    },
    {
      path: '/request',
      name: 'request',
      component: Request
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js